import React from 'react';
import { Box } from '@cp/ds/src/components/box';
import { Switch } from '@cp/ds/src/components/switch';
import { useController } from 'react-hook-form';
import { addDays, format } from 'date-fns';
import { FormFieldName } from '../../model/form';
import { DATE_VALUE_FORMAT } from '../../model/const';
import { AvailableOnlyFieldProps } from './model';

export const AvailableOnlyField: React.FC<AvailableOnlyFieldProps> = ({ careerId, form, sx, careerDictionary, reducedWidth }) => {
  const { field } = useController({ name: FormFieldName.AvailableOnly, control: form.control });

  const handleChange = React.useCallback(
    (newValue: boolean) => {
      if (newValue) {
        form.setValue(FormFieldName.Date, format(addDays(new Date(), 1), DATE_VALUE_FORMAT));
        form.setValue(FormFieldName.Start, null);
        form.setValue(FormFieldName.End, null);
      } else {
        form.setValue(FormFieldName.Date, null);
        form.setValue(FormFieldName.Start, null);
        form.setValue(FormFieldName.End, null);
      }

      field.onChange(newValue);
    },
    [field, form],
  );

  return (
    <Box sx={sx}>
      <Switch
        inputName={FormFieldName.AvailableOnly}
        label={
          <>
            Показать только{reducedWidth ? <br /> : ' '}доступных{' '}
            {/* {careerDictionary?.[careerId].translation.namePluralGenitive ?? 'специалистов'} */}
          </>
        }
        labelTypography="small text bold"
        onChange={handleChange}
        value={field.value}
      />
    </Box>
  );
};
